import {
  Qualification,
  QualificationDatum,
  SelectableQualificationDatum,
  SurveyQualificationTab,
} from '../models';

const isSelectableDatum = (
  datum: QualificationDatum,
): datum is SelectableQualificationDatum => 'id' in datum;

export function qualificationToSurveyQualification(
  qualification: Qualification,
): SurveyQualificationTab {
  return {
    id: String(qualification.qualificationCode),
    label: qualification.qualificationName,
    options: qualification.data
      .filter(isSelectableDatum)
      .sort((first, second) => first.id - second.id)
      .map((datum) => ({
        id: String(datum.id),
        text: datum.text,
        selected: false,
      })),
    hasQuotas: false,
    hasNestedQuotas: false,
    isCensusEligible: qualification.census.enabled,
    isCensusApplied: false,
    qualificationCode: qualification.qualificationCode,
    isLocation: qualification.isLocation,
    renderType: qualification.renderType,
  };
}
